<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      show-save-button
      unit="商品类别"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="125px"
      :form-rules="rules"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col>
            <el-table
              ref="table"
              :data="types"
              row-key="RecordId"
              border
              stripe
              default-expand-all
            >
              <el-table-column type="index" align="center" width="45">
                <template #header>
                  <el-checkbox
                    v-model="topRow.Checked"
                    @change="handleAllSelect(topRow.Checked)"
                  ></el-checkbox>
                </template>
                <template slot-scope="{ row }">
                  <el-checkbox
                    v-model="row.Checked"
                    @change="handleSelect(row)"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                label="类别名称"
                :width="$store.state.isMB ? '100px' : ''"
              >
                <template slot-scope="{ row }">{{ row.TypeName }}</template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import storeSelect from "@/components/shop/store/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    storeSelect,
  },
  data() {
    return {
      data: {
        StoreId: 0,
      },
      list: [],
      api: require("@/api/goods/type").default,
      api2: require("@/api/goods/typeplatform").default,
      isMB: this.$store.state.isMB,
      rules: {
        StoreId: [{ required: true, message: "门店不能为空" }],
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      types: [],
      defaultProps: {
        children: "children",
        label: "TypeName",
      },
      checkedIds: [],
      selectedData: [],
      deleteData: [],
      allTypes: [],
      topRow: {
        Checked: false,
        children: this.types,
      },
    };
  },

  methods: {
    onReload() {
      this.api.getStoreTypes().then((res) => {
        if (res.Code == 0) {
          this.allTypes = res.Data.Dtos;
          console.log(res.Data, "aa");
          this.types = this.$commonJs.toTreeData(
            res.Data.Dtos,
            "RecordId",
            "TypeIdParent",
            "children",
            null
          );
          this.topRow.Checked = this.types.some((item) => item.Checked == true);
          this.topRow.children = this.types;
        }
      });

      // this.api2.list({}).then((res) => {
      //   this.checkedIds = [];
      //   if (res.Code == 0) {
      //     this.allTypes = res.Data;
      //     this.api.list({ StoreId: this.data.StoreId }).then((rst) => {
      //       if (rst.Code == 0) {
      //         var sData = rst.Data;

      //         console.log(sData, "sdata");
      //         var platformIds = sData.map((x) => x.PlatformId);
      //         this.checkedIds = platformIds;
      //         console.log(platformIds, "pids");
      //         res.Data.forEach((item) => {
      //           item.Checked = false;
      //           if (platformIds.includes(item.RecordId)) {
      //             item.T = 1;
      //             item.Checked = true;
      //           } else {
      //             item.T = 0;
      //           }
      //         });
      //       }
      //     });
      //     this.types = this.$commonJs.toTreeData(
      //       res.Data,
      //       "RecordId",
      //       "TypeIdParent",
      //       "children",
      //       null
      //     );
      //     console.log("types", this.types);
      //     this.topRow.Checked = this.types.some((item) => item.Checked == true);
      //     this.topRow.children = this.types;
      //   }
      // });
    },
    handleAllSelect(val, state = 0) {
      this.setChild(this.types, val);
    },
    handleSelect(row, state = 0) {
      if (row.TypeIdParent != 0) {
        this.setParent(row.TypeIdParent);
      }
      if (row.children) {
        this.setChild(row.children, row.Checked);
      }
      this.topRow.Checked = this.types.some((item) => item.Checked == true);
    },
    setParent(pid, index) {
      let parent = this.types.find((item) => item.RecordId == pid);
      if (parent) {
        if (index != undefined) {
          if (parent.TypeIdParent != 0) {
            this.setParent(parent.TypeIdParent, index);
          }
        } else {
          parent.Checked = parent.children.some((s) => s.Checked == true);
          if (parent.TypeIdParent != 0) {
            this.setParent(parent.TypeIdParent);
          }
        }
      }
    },
    setChild(data, value, index) {
      if (index != undefined) {
        data.forEach((item) => {
          if (item.children) {
            this.setChild(item.children, value, index);
          }
        });
      } else {
        data.forEach((item) => {
          item.Checked = value;
          if (item.children) {
            this.setChild(item.children, value);
          }
        });
      }
    },
    getCheckedRows() {
      let checkedRow = this.types.filter((item) => item.Checked == true);
      return checkedRow;
    },
    onCreateOpened(row) {},
    onEditOpened(data) {},
    onBeforeSave() {
      var nodes = this.getCheckedRows();
      console.log(nodes, "nodes");
      if (nodes.length == 0) {
        this.$message.error("类别不能为空");
        return false;
      }
      nodes.forEach((item) => {
        item.StoreId = this.data.StoreId;
        if (item.children) {
          item.children.forEach((x) => {
            x.StoreId = this.data.StoreId;
          });
        }
      });
      this.api.moreSave(nodes).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.types = [];
      this.checkedIds = [];
      this.data.StoreId = 0;
    },
  },
};
</script>